import type { TableColumn } from '@ipfabric/utils';
import { withPathLookupLink } from './columnOverrides/aimPathLookupLinkOverride';
import {
  aimApplicationsFlowsCalculatedColumnOverride,
  aimApplicationsNameColumnOverride,
  aimDeviceCountColumnOverride,
  aimFlowsCalculationStatusColumnOverride,
} from './columnOverrides/aimTableColumnOverrides';

/**
 * Frontend customization of a single OAS-driven column, keyed by table id and
 * column key.
 *
 * Use this — rather than `apiTableActionsColumnsMap` — when the customization
 * belongs to an existing column: an appended frontend-only column always lands
 * at the far right and carries no filter, sort or CSV export.
 *
 * An override may replace the cell render (`renderContent`) or just the cell's
 * link (`format.createLinkProps`); the latter keeps the column's normal render.
 *
 * Row type is `any` for the same reason as in `apiTableActionsColumnsMap`: the
 * registry is keyed by string, so the row type of each table is not known here.
 */
export type ApiTableColumnOverride = (
  column: TableColumn<any>,
) => TableColumn<any>;

export const apiTableColumnOverridesMap: {
  [tableId: string]: { [columnKey: string]: ApiTableColumnOverride };
} = {
  '/inventory/applications': {
    name: aimApplicationsNameColumnOverride,
    flowsCalculated: aimApplicationsFlowsCalculatedColumnOverride,
    devices: aimDeviceCountColumnOverride,
  },
  '/inventory/applications/flows': {
    applicationFlow: withPathLookupLink,
    pathLookupsCalculationStatus: aimFlowsCalculationStatusColumnOverride,
    devices: aimDeviceCountColumnOverride,
  },
  '/inventory/applications/devices': {
    applicationFlow: withPathLookupLink,
  },
};
